/**
 * CreatorAvatar — small round avatar for a creator wallet address.
 * Falls back to a User icon when no avatar is set or the profile is missing.
 */
import React from 'react';
import { User } from 'lucide-react';
import { useRealtimeData } from '@/hooks/use-realtime-data';
import { subscribeUserAvatars, UserAvatarsResponse } from '@/lib/collections/userAvatars';

interface CreatorAvatarProps {
  walletAddress: string;
  size?: number;
}

export const CreatorAvatar: React.FC<CreatorAvatarProps> = ({ walletAddress, size = 20 }) => {
  const { data: avatarData } = useRealtimeData<UserAvatarsResponse | null>(
    subscribeUserAvatars,
    !!walletAddress,
    walletAddress,
  );

  const avatarUrl = avatarData?.avatarUrl ?? null;

  return (
    <div
      style={{
        flexShrink: 0,
        width: size,
        height: size,
        borderRadius: '50%',
        background: 'rgba(167,139,250,0.12)',
        border: '1px solid rgba(167,139,250,0.35)',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt=""
          loading="lazy"
          decoding="async"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        <User size={Math.round(size * 0.6)} color="rgba(167,139,250,0.7)" strokeWidth={1.75} />
      )}
    </div>
  );
};

export default CreatorAvatar;
